import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "aura-chat-layout flex h-full min-h-0 flex-col bg-white" }
const _hoisted_2 = {
  ref: "messagesContainer",
  class: "min-h-0 flex-1 space-y-4 overflow-y-auto px-4 py-4 sm:px-6"
}
const _hoisted_3 = {
  key: 0,
  class: "flex h-full flex-col items-center justify-center px-2 sm:px-4"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mb-2 text-center text-xl font-bold text-[#242B59] sm:text-2xl" }
const _hoisted_6 = { class: "mb-8 text-center text-[#626468]" }
const _hoisted_7 = { class: "grid w-full max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-sm font-medium text-[#626468]" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "w-full space-y-4" }
const _hoisted_12 = { class: "max-w-[90%] rounded-2xl rounded-bl-md bg-gray-50 px-4 py-2.5 text-[#242B59] sm:max-w-[85%]" }
const _hoisted_13 = {
  key: 0,
  class: "mt-2 pt-1"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "mt-3 space-y-2"
}
const _hoisted_16 = { class: "text-xs font-semibold uppercase tracking-wider text-[#737373]" }
const _hoisted_17 = { class: "flex flex-wrap gap-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "grid grid-cols-2 gap-3"
}
const _hoisted_20 = { class: "text-xs text-[#808288]" }
const _hoisted_21 = { class: "text-lg font-bold text-[#242B59]" }
const _hoisted_22 = {
  key: 5,
  class: "flex flex-wrap gap-3"
}
const _hoisted_23 = {
  key: 6,
  class: "space-y-3"
}
const _hoisted_24 = {
  key: 0,
  class: "flex flex-row gap-3"
}
const _hoisted_25 = { class: "flex h-10 w-10 flex-shrink-0 items-center justify-center overflow-hidden rounded-xl bg-[#48DDC3]/20" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "rounded-2xl rounded-bl-md bg-gray-50 px-4 py-3" }
const _hoisted_28 = {
  key: 0,
  class: "aura-typewriter mb-2 text-xs font-medium text-[#626468]"
}
const _hoisted_29 = { class: "aura-chat-footer shrink-0 border-t border-gray-100 bg-white px-4 py-3 sm:px-6 sm:py-4" }
const _hoisted_30 = { class: "aura-chat-input mx-auto flex max-w-3xl items-end gap-3" }
const _hoisted_31 = { class: "aura-chat-input-field relative flex flex-1 items-center gap-3 rounded-full border border-[#E5E5E5] bg-white px-4 py-3 shadow-[0px_2px_12px_rgba(0,0,0,0.03)] transition-all focus-within:border-[#48DDC3] focus-within:shadow-md" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "mt-2 flex items-start justify-between gap-3 text-[11px] leading-4 text-gray-400 sm:mt-3 sm:items-center sm:text-xs" }
const _hoisted_35 = { class: "min-w-0" }
const _hoisted_36 = { class: "shrink-0 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Messages area with internal scroll "),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Empty state with example prompts "),
      (!$setup.hasMessages && !$props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createCommentVNode(" Icon "),
            _createElementVNode("img", {
              src: $setup.auraMainIcon,
              class: "mb-6 h-16 w-16",
              alt: "AURA"
            }, null, 8 /* PROPS */, _hoisted_4),
            _createCommentVNode(" Title "),
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('aura.chat.emptyState.title')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_6, _toDisplayString($setup.props.contextTitle
                            ? _ctx.$t('aura.chat.emptyState.contextSubtitle', {
                                  context: $setup.props.contextTitle,
                              })
                            : _ctx.$t('aura.chat.emptyState.fallbackSubtitle')), 1 /* TEXT */),
            _createCommentVNode(" Example prompts grid "),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.emptyPrompts, (prompt, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  class: "flex items-center justify-between gap-3 rounded-2xl border border-[#E5E5E5] bg-white p-4 text-left shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] transition-all hover:border-[#48DDC3] hover:shadow-md",
                  onClick: ($event: any) => ($setup.selectPrompt(prompt))
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(prompt), 1 /* TEXT */),
                  _createVNode($setup["PlusIcon"], { class: "h-5 w-5 flex-shrink-0 text-[#A1A1A1]" })
                ], 8 /* PROPS */, _hoisted_8))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Messages list "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.messages, (message, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: message.id || index,
                class: _normalizeClass([
                        'flex min-w-0 gap-3',
                        message.type === 'user' ? 'flex-row-reverse' : 'flex-row',
                    ])
              }, [
                _createCommentVNode(" Avatar "),
                _createElementVNode("div", {
                  class: _normalizeClass([
                            'flex h-10 w-10 flex-shrink-0 items-center justify-center overflow-hidden rounded-xl',
                            message.type === 'user' ? 'bg-[#242B59] text-white' : 'bg-[#48DDC3]/20',
                        ])
                }, [
                  (message.type === 'user')
                    ? (_openBlock(), _createBlock($setup["UserIcon"], {
                        key: 0,
                        class: "h-5 w-5"
                      }))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: $setup.auraConversationIcon,
                        class: "h-full w-full",
                        alt: "AURA"
                      }, null, 8 /* PROPS */, _hoisted_10))
                ], 2 /* CLASS */),
                _createCommentVNode(" Message bubble "),
                _createElementVNode("div", {
                  class: _normalizeClass(["aura-message-bubble", [
                            'min-w-0',
                            message.type === 'user'
                                ? 'max-w-[90%] rounded-2xl rounded-br-md bg-[#242B59] px-4 py-2.5 text-white sm:max-w-[85%]'
                                : message.response
                                  ? 'max-w-full flex-1'
                                  : message.type === 'error'
                                    ? 'max-w-[90%] rounded-2xl rounded-bl-md border border-red-200 bg-red-50 px-4 py-2.5 text-red-800 sm:max-w-[85%]'
                                    : 'max-w-[90%] rounded-2xl rounded-bl-md bg-gray-50 px-4 py-2.5 text-[#242B59] sm:max-w-[85%]',
                        ]])
                }, [
                  _createCommentVNode(" Simple text message "),
                  (!message.response)
                    ? (_openBlock(), _createBlock($setup["AuraRichText"], {
                        key: 0,
                        class: "whitespace-pre-wrap text-sm",
                        text: message.content
                      }, null, 8 /* PROPS */, ["text"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createCommentVNode(" Structured response "),
                        _createElementVNode("div", _hoisted_11, [
                          _createCommentVNode(" Summary / blocked message "),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode($setup["AuraRichText"], {
                              class: "whitespace-pre-wrap text-sm",
                              text: 
                                        message.response.summary?.content ||
                                        message.response.status?.message ||
                                        message.content
                                    
                            }, null, 8 /* PROPS */, ["text"])
                          ]),
                          _createCommentVNode(" Retry button for temporal conflicts "),
                          (
                                    message.response?.status?.code === 'BLOCKED_TEMPORAL_CONFLICT'
                                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "inline-flex items-center gap-1.5 rounded-lg border border-amber-300 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-[#A16207] shadow-sm transition-all hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1",
                                  onClick: ($event: any) => ($setup.retryFailedQuestion(index))
                                }, [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("svg", {
                                    class: "h-3.5 w-3.5",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      d: "M4 4v5h.582m15.356 2A8.001 8.001 0 1121.21 7.89M9 11l3 3L22 4"
                                    })
                                  ], -1 /* CACHED */),
                                  _createTextVNode(" Perguntar novamente ", -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_14)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Disambiguation options (agent / queue) "),
                          (
                                    [
                                        'FILTER_DISAMBIGUATION',
                                        'DISAMBIGUATION_REQUIRED',
                                        'AGENT_NAME_AMBIGUOUS',
                                    ].includes(message.response?.status?.code)
                                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("p", _hoisted_16, _toDisplayString($setup.getFilterDisambiguationLabel(message)), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getFilterDisambiguationOptions(message), (match) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: match.id,
                                      type: "button",
                                      class: "rounded-lg border border-[#48DDC3] bg-[#48DDC3]/10 px-3 py-1.5 text-sm font-medium text-[#242B59] transition-all hover:bg-[#48DDC3]/30",
                                      onClick: ($event: any) => (
                                            _ctx.$emit('send-with-filter', {
                                                message: $props.messages[index - 1]?.content,
                                                filterKey:
                                                    $setup.getFilterDisambiguationFilterKey(message),
                                                filterId: Number(match.id),
                                            })
                                        )
                                    }, _toDisplayString(match.label || match.name), 9 /* TEXT, PROPS */, _hoisted_18))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" KPIs "),
                          (message.response.kpis?.items?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.response.kpis.items, (kpi) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: kpi.name,
                                    class: "rounded-xl border border-[#E5E5E5] bg-white p-3"
                                  }, [
                                    _createElementVNode("p", _hoisted_20, _toDisplayString($setup.formatAuraDateLabel(kpi.name)), 1 /* TEXT */),
                                    _createElementVNode("p", _hoisted_21, _toDisplayString($setup.formatAuraMetric(
                                                kpi.value,
                                                $setup.getKpiUnit(message, kpi.unit),
                                            )), 1 /* TEXT */),
                                    (kpi.trendValue)
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 0,
                                          class: _normalizeClass([
                                            'text-xs',
                                            kpi.trend === 'up'
                                                ? 'text-green-500'
                                                : kpi.trend === 'down'
                                                  ? 'text-red-500'
                                                  : 'text-gray-400',
                                        ])
                                        }, _toDisplayString(kpi.trendValue), 3 /* TEXT, CLASS */))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Chart "),
                          (message.response.visualization?.status === 'complete')
                            ? (_openBlock(), _createBlock($setup["AuraVisualizationPanel"], {
                                key: 3,
                                plan: message.response.visualization
                              }, null, 8 /* PROPS */, ["plan"]))
                            : (message.response.chart?.status === 'complete')
                              ? (_openBlock(), _createBlock($setup["AuraChartBlock"], {
                                  key: 4,
                                  chart: message.response.chart
                                }, null, 8 /* PROPS */, ["chart"]))
                              : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Insights "),
                          (message.response.insights?.items?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.response.insights.items, (insight, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: idx,
                                    class: "w-full sm:w-auto"
                                  }, [
                                    _createVNode($setup["AuraInsightCard"], { insight: insight }, null, 8 /* PROPS */, ["insight"])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Actions "),
                          (message.response.actions?.items?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.response.actions.items, (action, idx) => {
                                  return (_openBlock(), _createBlock($setup["AuraActionCard"], {
                                    key: idx,
                                    action: action,
                                    loading: $props.isLoading,
                                    disabled: $props.disabled,
                                    onExecute: $setup.executeAction
                                  }, null, 8 /* PROPS */, ["action", "loading", "disabled"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                  _createElementVNode("span", {
                    class: _normalizeClass([
                                'mt-1 block text-xs',
                                message.type === 'user' ? 'text-white/70' : 'text-gray-400',
                            ])
                  }, _toDisplayString($setup.formatTime(message.createdAt)), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */)),
            _createCommentVNode(" Loading indicator "),
            ($props.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("img", {
                      src: $setup.auraConversationIcon,
                      class: "h-full w-full",
                      alt: "AURA"
                    }, null, 8 /* PROPS */, _hoisted_26)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    ($props.isLoading && $props.loadingMessage)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString($setup.typewriterText), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
                      _createElementVNode("div", { class: "h-2 w-2 animate-bounce rounded-full bg-[#48DDC3] [animation-delay:-0.3s]" }),
                      _createElementVNode("div", { class: "h-2 w-2 animate-bounce rounded-full bg-[#48DDC3] [animation-delay:-0.15s]" }),
                      _createElementVNode("div", { class: "h-2 w-2 animate-bounce rounded-full bg-[#48DDC3]" })
                    ], -1 /* CACHED */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ], 512 /* NEED_PATCH */),
    _createCommentVNode(" Fixed footer with input "),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createCommentVNode(" Input container with border "),
        _createElementVNode("div", _hoisted_31, [
          _createVNode($setup["PlusIcon"], { class: "h-5 w-5 text-gray-400" }),
          _withDirectives(_createElementVNode("textarea", {
            ref: "textareaRef",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputMessage) = $event)),
            disabled: $props.disabled,
            maxlength: $setup.MAX_MESSAGE_LENGTH,
            rows: "1",
            class: "w-full resize-none border-0 bg-transparent text-sm text-[#242B59] placeholder-gray-400 focus:outline-none focus:ring-0",
            placeholder: "Pergunte alguma coisa",
            onKeydown: $setup.handleKeydown,
            onInput: $setup.handleInput
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_32), [
            [_vModelText, $setup.inputMessage]
          ])
        ]),
        _createCommentVNode(" Send button "),
        _createElementVNode("button", {
          disabled: !$setup.canSend,
          class: "flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-[#F5F5F5] text-gray-400 transition-all hover:bg-[#242B59] hover:text-white disabled:cursor-not-allowed disabled:opacity-50",
          onClick: $setup.sendMessage
        }, [
          _createVNode($setup["PaperAirplaneIcon"], { class: "h-5 w-5" })
        ], 8 /* PROPS */, _hoisted_33)
      ]),
      _createCommentVNode(" Disclaimer "),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('aura.chat.disclaimer')), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('aura.chat.remainingCharacters', { count: $setup.remainingCharacters })), 1 /* TEXT */)
      ])
    ])
  ]))
}